import { snakeCase, mapKeys } from "lodash";
import qs from "query-string";

import { DTYPES } from "./constants";

const SOURCE_ID = "enverus_landtrac_units";
const LAYER_ID = "enverus_landtrac_units";
const BORDER_HIGHLIGHT_LAYER_ID = "enverus_landtrac_units_highlight";
const FILTER_LAYER_IDS = [LAYER_ID];
const CLICKABLE_LAYERS = [LAYER_ID];
const UNIQUE_COLUMN = "api_uwi_10";

const API_BASE_ENDPOINT = "enverus-landtrac-units";

const INITIAL_FILTER_STATE = {
  county: {
    column: "county",
    label: "County",
    dtype: DTYPES.STRING,
    value: [],
    excludeSelected: false,
    excludeNullValues: false,
  },
  unit_name: {
    column: "unit_name",
    label: "Unit Name",
    dtype: DTYPES.STRING,
    value: [],
    excludeSelected: false,
    excludeNullValues: false,
  },
  api_uwi_10: {
    column: "api_uwi_10",
    label: "API 10",
    dtype: DTYPES.STRING,
    value: [],
    excludeSelected: false,
    excludeNullValues: false,
  },
  rrc_id: {
    column: "rrc_id",
    label: "RRC ID",
    dtype: DTYPES.STRING,
    value: [],
    excludeSelected: false,
    excludeNullValues: false,
  },
};

const EXPORT_COLUMNS = [
  { key: "id", label: "ID" },
  { key: "api_uwi_10", label: "API 10" },
  { key: "unit_name", label: "Unit Name" },
  { key: "rrc_id", label: "RRC ID" },
  { key: "state", label: "State" },
  { key: "county", label: "County" },
  { key: "acres", label: "Acres" },
  {
    key: "created_at",
    label: "Created At",
    type: "date",
    format: "YYYY-MM-DD",
  },
  {
    key: "updated_at",
    label: "Updated At",
    type: "date",
    format: "YYYY-MM-DD",
  },
];

const STYLES = {
  "fill-outline-color": "#000000",
  "fill-color": "#f0ad4e",
  "fill-opacity": 0.3,
};

const BORDER_HIGHLIGHT_STYLES = {
  "line-color": "#000",
  "line-width": 3,
};

const ADD_BEFORE = "Laterals";

const buildTileUrl = (params = {}) => {
  const authToken = localStorage.getItem("authToken");
  const snakeParams = mapKeys(params, (_, k) => snakeCase(k));
  const queryString = qs.stringify(snakeParams, { skipNull: true });
  const suffix = queryString ? `&${queryString}` : "";

  return `${process.env.REACT_APP_SERVER_URL}/api/${API_BASE_ENDPOINT}/tiles/{z}/{x}/{y}.pbf?access_token=${authToken}${suffix}`;
};

const setTiles = (mapRef, options) => {
  const source = mapRef.current?.getSource(SOURCE_ID);

  if (source) {
    source.setTiles([buildTileUrl(options)]);
  }
};

const addSource = (mapRef) => {
  if (!mapRef.current.getSource(SOURCE_ID)) {
    mapRef.current.addSource(SOURCE_ID, {
      type: "vector",
      tiles: [buildTileUrl()],
      minzoom: 8,
      maxzoom: 22,
    });
  }
};

const addLayers = (mapRef) => {
  if (!mapRef.current.getLayer(LAYER_ID)) {
    mapRef.current.addLayer(
      {
        id: LAYER_ID,
        type: "fill",
        source: SOURCE_ID,
        "source-layer": SOURCE_ID,
        layout: {
          visibility: "none",
        },
        paint: STYLES,
      },
      ADD_BEFORE
    );
  }

  if (!mapRef.current.getLayer(BORDER_HIGHLIGHT_LAYER_ID)) {
    mapRef.current.addLayer(
      {
        id: BORDER_HIGHLIGHT_LAYER_ID,
        type: "line",
        source: SOURCE_ID,
        "source-layer": SOURCE_ID,
        layout: {},
        paint: BORDER_HIGHLIGHT_STYLES,
        filter: ["in", UNIQUE_COLUMN, ""],
      }
      // ADD_BEFORE
    );
  }
};

const addAll = (mapRef) => {
  addSource(mapRef);
  addLayers(mapRef);
};

export {
  EXPORT_COLUMNS,
  SOURCE_ID,
  LAYER_ID,
  BORDER_HIGHLIGHT_LAYER_ID,
  FILTER_LAYER_IDS,
  CLICKABLE_LAYERS,
  UNIQUE_COLUMN,
  STYLES,
  BORDER_HIGHLIGHT_STYLES,
  API_BASE_ENDPOINT,
  INITIAL_FILTER_STATE,
  addAll,
  setTiles,
};
